/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseFileInfo
 */
export interface CaseFileInfo {
    /**
     * 
     * @type {string}
     * @memberof CaseFileInfo
     */
    documentType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseFileInfo
     */
    tag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseFileInfo
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseFileInfo
     */
    shortSummary?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseFileInfo
     */
    longSummary?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CaseFileInfo
     */
    dates?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CaseFileInfo
     */
    parties?: Array<string> | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CaseFileInfo
     */
    documentSegments?: { [key: string]: number; } | null;
}

export function CaseFileInfoFromJSON(json: any): CaseFileInfo {
    return CaseFileInfoFromJSONTyped(json, false);
}

export function CaseFileInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseFileInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentType': !exists(json, 'documentType') ? undefined : json['documentType'],
        'tag': !exists(json, 'tag') ? undefined : json['tag'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'shortSummary': !exists(json, 'shortSummary') ? undefined : json['shortSummary'],
        'longSummary': !exists(json, 'longSummary') ? undefined : json['longSummary'],
        'dates': !exists(json, 'dates') ? undefined : json['dates'],
        'parties': !exists(json, 'parties') ? undefined : json['parties'],
        'documentSegments': !exists(json, 'documentSegments') ? undefined : json['documentSegments'],
    };
}

export function CaseFileInfoToJSON(value?: CaseFileInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'documentType': value.documentType,
        'tag': value.tag,
        'title': value.title,
        'shortSummary': value.shortSummary,
        'longSummary': value.longSummary,
        'dates': value.dates,
        'parties': value.parties,
        'documentSegments': value.documentSegments,
    };
}


